<template>
  <div
    :class="{
      flex: true,
      'hekate-input-selected': isSelected,
      'hekate-input-highlighted': isHighlighted,
    }"
    :hekate-input-value="persona"
    hekate-input-field-name="whatIsYourExperience"
    @click="emit('select', { persona, personaDetails: personaDetails ?? '', personaTitle })"
    @mouseenter="emit('hover', { personaTitle })"
  >
    <div
      :class="{
        'w-full lg:w-1/2': true,
      }"
    >
      <div
        :class="{
          'persona-box relative mx-auto mb-5 cursor-pointer rounded-md border border-www-color-neutral-very-light px-4 py-2 text-center transition-all duration-200 ease-in-out md:px-10': true,
        }"
        @mouseleave="emit('hoverEnd')"
      >
        <h4
          :hekate-persona-detail="personaDetails"
          :class="{
            'mb-0 text-base font-bold leading-7 text-www-color-neutral-medium-dark md:text-xl': true,
          }"
        >
          {{ personaTitle }}
        </h4>
        <p
          :class="{
            'text-sm italic leading-7 text-www-color-neutral-medium-dark md:text-base': true,
          }"
        >
          {{ personaSubtitle }}
        </p>
      </div>
    </div>
    <div
      :class="{
        'hidden w-full lg:block lg:w-1/2': true,
      }"
    >
      <div
        :class="{
          'persona-details absolute top-1/2 flex h-full -translate-y-1/2 flex-col justify-center px-60px opacity-0 transition-all duration-200 ease-in-out': true,
        }"
      >
        <div>
          <ImageAtom
            v-if="image"
            v-bind="image"
            :loading="'eager'"
            :class="{
              'mb-4 w-56': true,
            }"
          />
        </div>
        <component
          :is="getComponent(imageDescription._type)"
          :value="imageDescription"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ImageAtom from '~/components/Atmos/ImageAtom/ImageAtom.vue';
import type { UssPersonaObject } from '~/sanity/types';
import { getComponent } from '~/components/Mapper';

defineProps<UssPersonaObject & { isSelected?: boolean; isHighlighted?: boolean }>();
const emit = defineEmits<{
  select: [{ persona: string; personaDetails: string; personaTitle: string }];
  hover: [{ personaTitle: string }];
  hoverEnd: [];
}>();
</script>

<style></style>
